import React, { Component } from "react"
import domtoimage from "dom-to-image"
import classnames from "classnames"

class ImageExport extends Component {
	constructor(props) {
		super(props)
		this.state = {
			active: false,
			block: this.props.block || false,
		}
	}

	export = (e) => {
		let scale = 3
		this.setState({ active: true })
		let icon = e.target.parentElement
		let element = icon.parentElement
		if (this.props.twoUp) {
			element = element.parentElement
		}
		// To prevent internal elements with margins that would mess up dimensions of the element...eg internal h3 with marginTop
		element.style.overflow = "auto"
		let width = element.offsetWidth * scale + 50
		let height = element.offsetHeight * scale + 50
		let file = this.props.name
		let origPad = {
			top: element.style.paddingTop,
			left: element.style.paddingLeft,
		}
		if (origPad.top < 25) {
			element.style.paddingTop = "25px"
		}
		if (origPad.left < 25) {
			element.style.paddingLeft = "25px"
		}

		domtoimage
			.toJpeg(element, {
				width,
				height,
				bgcolor: "#fff",
				style: {
					transform: "scale(" + scale + ")",
					transformOrigin: "top left",
				},
				filter: function (node) {
					// Hide all elements that have data-html2canvas-ignore - i know this is from anotehr library but may as well re-use.
					if (
						node &&
						typeof node.getAttribute === "function" &&
						node.getAttribute("data-html2canvas-ignore") === "true"
					)
						return false
					return true
				},
			})
			.then(function (dataUrl) {
				var link = document.createElement("a")
				link.download = `${file}.jpg`
				link.href = dataUrl
				link.click()
				element.style.paddingTop = origPad.top
				element.style.paddingLeft = origPad.left
			})
			.then(() => {
				this.setState({ active: false })
			})
	}

	render() {
		return (
			<div onClick={this.export} className={classnames("imageExport", { block: this.state.block })}>
				<i
					title="Export to JPG"
					data-html2canvas-ignore="true"
					className={classnames("fas fa-image", { hide: this.state.active })}
				/>
			</div>
		)
	}
}

export default ImageExport
